/**
 * MIRA Toast Component
 * Wraps Shadcn Toast with MIRA design system styles
 */

import React from 'react';
import {
  ToastProvider,
  ToastViewport as ShadcnToastViewport,
  Toast as ShadcnToast,
  ToastTitle as ShadcnToastTitle,
  ToastDescription as ShadcnToastDescription,
  ToastClose,
  ToastAction,
} from '@/components/ui/toast';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/feedback/toast.module.css';

// Re-export provider and action components
export { ToastProvider, ToastClose, ToastAction };

export const ToastViewport = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnToastViewport
        ref={ref}
        className={cn(styles.miraToastViewport, className)}
        {...props}
      />
    );
  }
);

ToastViewport.displayName = 'MiraToastViewport';

export const Toast = React.forwardRef(
  ({ className, variant = 'default', ...props }, ref) => {
    return (
      <ShadcnToast
        ref={ref}
        variant={variant}
        className={cn(styles.miraToast, className)}
        {...props}
      />
    );
  }
);

Toast.displayName = 'MiraToast';

export const ToastTitle = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnToastTitle
        ref={ref}
        className={cn(styles.miraToastTitle, className)}
        {...props}
      />
    );
  }
);

ToastTitle.displayName = 'MiraToastTitle';

export const ToastDescription = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnToastDescription
        ref={ref}
        className={cn(styles.miraToastDescription, className)}
        {...props}
      />
    );
  }
);

ToastDescription.displayName = 'MiraToastDescription';
